// 默认渠道号
export const DEFAULT_CHANNEL = 'xubei';
// 默认客服系统地址
export const DEFAULT_SYSTEM_URL = 'https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1l45OHI&scene=SCE00006146';



// WEBPACK FOOTER //
// ./src/config/constants.js